import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getAll = () => vdkEmHappinessPortalApi.get('/usage-manuals');
const getLatest = () => vdkEmHappinessPortalApi.get('/usage-manuals/latest');
const getNextVersion = () => vdkEmHappinessPortalApi.get('/usage-manuals/next-version');
const upload = (file, language, targetVersion) => {
    const formData = new FormData();
    formData.append('File', file);
    formData.append('Language', language);
    if (targetVersion) {
        formData.append('TargetMajorVersion', String(targetVersion.major));
        formData.append('TargetMinorVersion', String(targetVersion.minor));
        formData.append('TargetPatchVersion', String(targetVersion.patch));
    }
    return vdkEmHappinessPortalApi.post('/usage-manuals/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};
const replaceFile = (id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return vdkEmHappinessPortalApi.put(`/usage-manuals/${id}/file`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};
const usageManualAPI = { getAll, getLatest, getNextVersion, upload, replaceFile };
export default usageManualAPI;
